import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import {
    changePaymentMethodValue,
    updatePaymentMethod,
    changeCurrentStep
} from '@/shared/store/slice/cartSlice'
import classNames from 'classnames'
import { useEffect } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

export const PaymentMethods = ({userInfo, cert}) => {
    const dispatch = useDispatch()

    const {
        customer,
        currentStep: step,
        paymentMethods: data,
        paymentMethodValue,
        shippingMethodValue,
    } = useSelector((state) => state.cartActions)

    useEffect(() => {
        dispatch(changeCurrentStep({currentStep: 3}))
    }, [dispatch])

    // Сортировка методов
    const methods = data ? Object.values(data) : []
    let sortedMethods = methods.sort((a, b) =>
        a.sort_order > b.sort_order ? 1 : -1
    )

    const handleChangeStep = () => {
        console.log('handleChangeStep - переход к оплате');
        console.log('paymentMethodValue:', paymentMethodValue);
        console.log('shippingMethodValue:', shippingMethodValue); 
        
        dispatch(updatePaymentMethod({ 
            payment_method: paymentMethodValue, 
            shipping_method: shippingMethodValue, 
            userInfo 
        }))
    }

    const handleChange = (type) => {
        dispatch(changePaymentMethodValue(type))
    }

    if (data === null || data === undefined || Object.keys(data).length === 0) {
        return <div>Ошибка загрузки способов оплаты</div>
    }

    if(cert) {
        sortedMethods = sortedMethods.filter((item)=>item?.code == 'modulbank');
    }
    
    return (
        <CardPlacingOrder
            stepTitle={'Шаг 3: Способ оплаты'}
            changeStep={handleChangeStep}
            className={classNames(step < 3 ? 'disabled-step' : '')}
            textButton={'Следующий шаг'}
            currentStep={step === 3}
            isValid={paymentMethodValue}
        >
            <h3>Выберите способ оплаты заказа:</h3>
            {sortedMethods.map((item) => (
                <InputGroup key={item.code}>
                    <Form.Check
                        checked={paymentMethodValue === item.code}
                        id={item.code}
                        type={'radio'}
                        name="payment_method"
                        onChange={() => handleChange(item.code)}
                    />
                    <label htmlFor={item.code}>
                        <span>{item.title}</span>
                    </label>
                </InputGroup>
            ))}
        </CardPlacingOrder>
    )
}